import React, {PropsWithChildren} from 'react';
import {Breadcrumbs} from "./Breadcrumbs";
import {Layout} from "./Layout";

export const Page: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Layout>
      <div className="px-4 sm:px-0">
        <Breadcrumbs />
      </div>
      {children}
    </Layout>
  );
};
